import { ClassNameProps, StyleProps } from "@hex-insights/core";
import { Icon, IconContainer } from "../../../../Components";

export type ModelIconProps = {
	size?: number;
	color?: string;
	backgroundColor?: string;
} & Partial<ClassNameProps & StyleProps>;

export const announcementModelColor = "var(--theme-colors__blue)";
export const announcementModelBackgroundColor = "var(--theme-colors__blue--background)";

export function AnnouncementModelIcon({
	size,
	color = announcementModelColor,
	backgroundColor = announcementModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Megaphone size={size} color={color} />
		</IconContainer>
	);
}

export const calendarEventModelColor = "var(--theme-colors__orange)";
export const calendarEventModelBackgroundColor = "var(--theme-colors__orange--background)";

export function CalendarEventModelIcon({
	size,
	color = calendarEventModelColor,
	backgroundColor = calendarEventModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.CalendarBlank size={size} color={color} />
		</IconContainer>
	);
}

export const newsletterModelColor = "var(--theme-colors__teal)";
export const newsletterModelBackgroundColor = "var(--theme-colors__teal--background)";

export function NewsletterModelIcon({
	size,
	color = newsletterModelColor,
	backgroundColor = newsletterModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.NewspaperClipping size={size} color={color} />
		</IconContainer>
	);
}

export const postModelColor = "var(--theme-colors__green)";
export const postModelBackgroundColor = "var(--theme-colors__green--background)";

export function PostModelIcon({
	size,
	color = postModelColor,
	backgroundColor = postModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.ImagesSquare size={size} color={color} />
		</IconContainer>
	);
}

export const userGroupModelColor = "var(--theme-colors__blue)";
export const userGroupModelBackgroundColor = "var(--theme-colors__blue--background)";

export function UserGroupModelIcon({
	size,
	color = userGroupModelColor,
	backgroundColor = userGroupModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Users size={size} color={color} />
		</IconContainer>
	);
}

export const permissionGroupModelColor = "var(--theme-colors__blue)";
export const permissionGroupModelBackgroundColor = "var(--theme-colors__blue--background)";

export function PermissionGroupModelIcon({
	size,
	color = permissionGroupModelColor,
	backgroundColor = permissionGroupModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.LockKey size={size} color={color} />
		</IconContainer>
	);
}
